module.exports = __webpack_public_path__ + "static/media/start-btn.703b6cc3.png";